import styled from 'styled-components';

export const Wrapper = styled.section`
  padding: 32px 16px;
  background-color: #f8fafc;
`;

export const SectionTitle = styled.h2`
  font-size: 22px;
  font-weight: 700;
  color: #0f172a;
  text-align: center;
  margin-bottom: 8px;
`;

export const SectionSubtitle = styled.div`
  font-size: 14px;
  color: #64748b;
  text-align: center;
  margin-bottom: 24px;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  @media (max-width: 360px) {
    grid-template-columns: 1fr;
  }
`;

export const AnalysisCard = styled.div`
  background: #ffffff;
  padding: 14px;
  border-radius: 12px;
  border: 1px solid #f1f5f9;
  display: flex;
  flex-direction: column;
  gap: 6px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.02);
`;

export const CardTitle = styled.h4`
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const CardDesc = styled.div`
  font-size: 12px;
  color: #64748b;
  margin: 0;
  line-height: 1.35;
`;
